import { EMPLOYEE_ZONES_ALIASES } from 'domain/shared/employee';

const EMPLOYEES_DASHBOARD_PATH = '/employees-dashboard';
export const WORKERS_DASHBOARD_PATH = '/workers-dashboard';
export const LEGACY_EMPLOYEES_DASHBOARD_PATH = EMPLOYEES_DASHBOARD_PATH;

export const READ_DELEGATED_DASHBOARD_ENTRIES = 'PEOPLE_MANAGEMENT_EMPLOYEE_DASHBOARD_DELEGATED_SEARCH';

export const EMPLOYEE_STATUS = {
  ACTIVE: 'ACTIVE',
  PROBATION: ' PROBATION',
  IN_DISMISSAL: 'IN_DISMISSAL',
  DISMISSAL: 'DISMISSAL',
  DISMISSED: 'DISMISSED',
  RELOCATION: 'RELOCATION',
};

export const DELEGATED_EMPLOYEE_ZONES_ALIASES = {
  SAFE: 'SAFE',
  MONITORING: 'MONITORING',
  CRITICAL: 'CRITICAL',
  ESCALATION: 'ESCALATION',
  DELEGATED: 'DELEGATED',
};

export const EMPLOYEE_ZONES = {
  [EMPLOYEE_ZONES_ALIASES.SAFE]: 'Safe',
  [EMPLOYEE_ZONES_ALIASES.MONITORING]: 'Monitoring',
  [EMPLOYEE_ZONES_ALIASES.CRITICAL]: 'Critical',
  [EMPLOYEE_ZONES_ALIASES.ESCALATION]: 'Escalation',
};

export const DELEGATED_EMPLOYEE_ZONES = {
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.SAFE]: 'Safe',
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.MONITORING]: 'Monitoring',
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.CRITICAL]: 'Critical',
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.ESCALATION]: 'Escalation',
  [DELEGATED_EMPLOYEE_ZONES_ALIASES.DELEGATED]: 'Delegated',
};

export const RETENTION_RISK_ISSUE_STATUS = {
  ACTIVE: 'ACTIVE',
  CLOSED: 'CLOSED',
};
